import dayjs from 'dayjs'

import { AppName } from 'root-constants'

export const WITHDRAWAL_ELIGIBLE_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'NO',
  'IS',
  'CH',
  'LI',
]

export const WITHDRAWAL_ELIGIBILITY_DAYS = 14

export const WITHDRAWAL_ELIGIBLE_APPS: string[] = [
  AppName.SPILIO,
  AppName.HELLO_PIANO,
  AppName.FAMIO,
  AppName.TESTORA,
  AppName.DANCEBIT,
  AppName.FITME,
  AppName.LUVLY,
  AppName.NUTRIMATE,
  AppName.NUTRI_WALKING,
  AppName.MYGROWTH,
  AppName.DEEPLY,
  AppName.AYAHPATH,
  AppName.DUMKA,
  AppName.FEMI,
  AppName.CREOSY,
]

type TWithdrawalEligibilityParams = {
  appName: string
  country?: string
  startTimestamp?: number
  wasWithdrawn?: boolean
}

export const isWithdrawalEligible = ({
  appName,
  country,
  startTimestamp,
  wasWithdrawn,
}: TWithdrawalEligibilityParams): boolean => {
  if (!WITHDRAWAL_ELIGIBLE_APPS.includes(appName)) return false
  if (!country || !startTimestamp) return false

  if (!WITHDRAWAL_ELIGIBLE_COUNTRIES.includes(country.toUpperCase())) {
    return false
  }

  return (
    dayjs().diff(dayjs.unix(startTimestamp), 'day') <=
      WITHDRAWAL_ELIGIBILITY_DAYS || !!wasWithdrawn
  )
}
